<dx-popup
  [(visible)]="displayDialog"
  [width]="'auto'"
  [height]="'auto'"
  [showCloseButton]="false"
  (onHidden)="onClose()">

  <div *dxTemplate="let _ of 'title'" class="print-inventaire-header">
    <div class="print-inventaire-title">
      <i class="far fa-file-pdf"></i>
      Extraction de l'inventaire
    </div>
    <yo-button
      class="print-inventaire-close"
      iconClass="fas fa-times"
      [theme]="ButtonThemeEnum.CANCEL"
      (onClick)="onClose()">
    </yo-button>
  </div>

  <div class="print-inventaire-content">
    <dx-check-box
      text="Détail des lots"
      [(value)]="detailsByLot">
    </dx-check-box>
    <dx-check-box
      text="Détail comptable"
      [(value)]="detailsAccounting">
    </dx-check-box>
    <dx-check-box
      text="Afficher la quantité"
      [(value)]="showQuantite">
    </dx-check-box>
    <dx-check-box
      text="Exclure les éléments vides"
      [(value)]="hideEmpty">
    </dx-check-box>

    <div class="print-inventaire-actions">
      <yo-button
        iconClass="fas fa-print"
        [theme]="ButtonThemeEnum.DEFAULT"
        (onClick)="extractInventaire(true)"
        tooltip="Imprimer l'inventaire"
        label="Imprimer">
      </yo-button>
      <yo-button
        iconClass="fas fa-file-excel"
        [theme]="ButtonThemeEnum.DEFAULT"
        (onClick)="extractInventaire(false)"
        tooltip="Exporter l'inventaire"
        label="Exporter">
      </yo-button>
    </div>
  </div>

</dx-popup>
